import React from 'react';
import { Link } from 'react-router-dom';
import { RotateCcw, Star, TrendingUp } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';
import LanguageSwitcher from '../LanguageSwitcher';
import '../../styles/premium-auth.css';

const Logo = ({ className, testId }) => (
  <Link to="/" className={className} data-testid={testId}>
    <div className="logo-icon">
      <img src="/assets/logo/logo-mark-128.png?v=4" alt="Copilote AI Business" style={{ width: 28, height: 28, borderRadius: 6 }} />
    </div>
    <div className="logo-text">
      <span className="logo-primary">COPILOTE AI</span>
      <span className="logo-secondary">BUSINESS</span>
    </div>
  </Link>
);

const FEATURES = [
  { Icon: RotateCcw, color: '#60A5FA', title: 'feature1Title', body: 'feature1Body' },
  { Icon: Star, color: '#F59E0B', title: 'feature2Title', body: 'feature2Body' },
  { Icon: TrendingUp, color: '#34D399', title: 'feature3Title', body: 'feature3Body' },
];

// Iter 123 — coquille commune login / mot de passe oublié / réinitialisation (100 % i18n, 6 langues).
export const AuthShell = ({ testId, mobileLogoTestId, children }) => {
  const { t } = useTranslation();
  return (
    <div className="premium-auth" data-testid={testId}>
      <div className="auth-bg">
        <div className="auth-gradient-orb orb-1"></div>
        <div className="auth-gradient-orb orb-2"></div>
        <div className="auth-grid-pattern"></div>
      </div>

      <div className="auth-container">
        <div className="auth-branding">
          <Logo className="auth-logo" testId={`${testId}-desktop-logo`} />
          <div className="branding-content">
            <h1>{t('rApp.login.branding.title')}</h1>
            <p>{t('rApp.login.branding.subtitle')}</p>
            <div className="branding-features">
              {FEATURES.map(({ Icon, color, title, body }) => (
                <div className="feature-item" key={title}>
                  <div className="feature-icon" aria-hidden="true">
                    <Icon size={20} strokeWidth={2} color={color} />
                  </div>
                  <div>
                    <strong>{t(`rApp.login.branding.${title}`)}</strong>
                    <span>{t(`rApp.login.branding.${body}`)}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="branding-footer">
            <p data-testid="auth-footer-copyright">© {new Date().getFullYear()} Copilote AI Business. All rights reserved.</p>
          </div>
        </div>

        <div className="auth-form-container">
          <div className="auth-lang-switcher" data-testid={`${testId}-lang-switcher`}>
            <LanguageSwitcher />
          </div>
          <div className="auth-form-wrapper">
            <Logo className="auth-logo auth-logo-mobile" testId={mobileLogoTestId || `${testId}-mobile-logo`} />
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
